//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import CartSidebarPaynowPaymentMethod from '~/mixins/stripe/paynow/cart-sidebar'
import PageMixin from '~/mixins/page'
import PlansMixin from '~/mixins/plans'
import { getAreaFromTest, getTestFromBiomarker } from '~/utils/biomarkerMatching'
import IntercomMixin from '@/mixins/intercom'
import GAEcommerce from '@/mixins/ga-ecommerce'

export default {
  mixins: [
    PageMixin,
    CartSidebarPaynowPaymentMethod,
    PlansMixin,
    GAEcommerce,
    IntercomMixin
  ],
  data () {
    return {
      starterTestIdParam: -1, // set onCreate
      plan: 'base-improvement-plan',
      starterTest: {},
      payNowButtonsId: ['#payment-request-button-header', '#payment-request-button-billing', '#payment-request-button-floating'],
      isPayUpfrontActiveAb: false
    }
  },
  head () {
    return {
      ...this.createSeoTags({
        title: this.$t(`test.seo.${this.biomarker}.title`),
        description: this.$t(`test.seo.${this.biomarker}.description`),
        url: `https://get-base.com/test/${this.biomarker}`,
        canonical: `https://get-base.com/test/${this.$t(`test.seo.${this.biomarker}.canonical`)}`,
        link: [
          {
            rel: 'preload',
            as: 'image',
            href: this.getStaticsObject(`/area/header_hero_0_${this.biomarker}.webp`)
          },
          {
            rel: 'preload',
            as: 'image',
            href: this.getStaticsObject(`/area/header_hero_0_${this.biomarker}_mobile.webp`)
          },
          {
            rel: 'preload',
            as: 'image',
            type: 'image/svg+xml',
            href: this.getStaticsObject('/area/header_specifications_0.svg')
          },
          {
            rel: 'preload',
            as: 'image',
            type: 'image/svg+xml',
            href: this.getStaticsObject('/area/header_specifications_1.svg')
          },
          {
            rel: 'preload',
            as: 'image',
            type: 'image/svg+xml',
            href: this.getStaticsObject('/area/header_specifications_2.svg')
          },
          {
            rel: 'preload',
            as: 'image',
            type: 'image/svg+xml',
            href: this.getStaticsObject('/area/header_benefits_0.svg')
          },
          {
            rel: 'preload',
            as: 'image',
            type: 'image/svg+xml',
            href: this.getStaticsObject('/area/header_benefits_1.svg')
          },
          {
            rel: 'preload',
            as: 'image',
            type: 'image/svg+xml',
            href: this.getStaticsObject('/area/header_benefits_2.svg')
          }
        ]
      })
    }
  },
  computed: {
    ...mapState('product', ['testMenu', 'planSelected', 'mainArea', 'fastTrackTestsAreas']),
    ...mapGetters({
      getPlanPriceRaw: 'product/getPlanPriceRaw',
      getPlanPrice: 'product/getPlanPrice',
      getTotalPrice: 'product/getTotalPrice',
      isAreaSelected: 'product/isAreaSelected',
      getTestMenuData: 'product/getTestMenuData'
    }),
    biomarker () {
      const rawBiomarker = this.$route.params.biomarker
      return rawBiomarker.replace(/-/g, '')
    },
    biomarkers () {
      return this.$t(`test.biomarkersInTest.${this.biomarker}`)
    },
    test () {
      return getTestFromBiomarker(this.biomarker)
    },
    area () {
      return getAreaFromTest(this.test.name)
    },
    steps () {
      return this.$t('test.howSteps')
    },
    carouselImagesParam () {
      return [
        `https://statics.get-base.com/area/header_hero_0_${this.biomarker}_mobile.webp`,
        `https://statics.get-base.com/quiz-results/starter_test_inside_box_${this.starterTest.test.collectionType}.webp`,
        `https://statics.get-base.com/quiz-results/starter_test_collection_${this.starterTest.test.collectionType}.webp`
      ]
    }
  },
  watch: {
    testMenu () {
      this.updateTestMenu()
    }
  },
  async created () {
    await this.$store.dispatch('quiz/resetQuizData')
    await this.$store.dispatch('product/resetProducts')

    await this.$store.dispatch('product/selectPlan', this.plan)
    await this.$store.dispatch('product/selectMainArea', this.area)

    // this.updateTestMenu()
    this.setPayNow()
  },
  mounted () {
    this.$store.commit('payment/setPaymentType', 'subscription')

    // Hack to fix the fact that starter test price is not loading on first attempt
    const reloaded = localStorage.getItem('reloaded')
    if (reloaded !== 'true') {
      localStorage.setItem('reloaded', 'true')
      setTimeout(function () {
        location.reload()
      }, 2500)
    }
  },
  methods: {
    updateTestMenu () {
      this.starterTest = this.getTestMenuData({ area: this.area, starterTestId: this.test.id })

      if (this.starterTest) {
        this.$store.dispatch('quiz/setGoalId', this.starterTest.goalId)
        this.$store.dispatch('product/setStarterTestId', this.test.id)
        this.$store.dispatch('product/selectStarterTest', this.starterTest.testTitle)
        this.$store.dispatch('product/setFasTrackTests', this.fastTrackTestsAreas[this.area])
      }
    },
    openFastTrackModal () {
      this.$root.$emit('bv::show::modal', 'fastTrackModal')
    },
    setPayNow () {
      this.$store.commit('product/setPayNowPlan', this.plan)
      this.$store.commit('product/setPayNowArea', this.area)
    }
  }
}
